import { all, call, put } from 'redux-saga/effects';

import * as InsuranceAnketaProviders from 'data-providers/insuranceAnketa';
import { selectWhen } from 'store/helpers';
import * as InsuranceAnketaActions from 'store/insuranceAnketa/actions';
import * as InsuranceAnketaConstants from 'store/insuranceAnketa/constants';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';

export const insuranceStageGetCustomers = new CreateStage({
  action: InsuranceConstants.ACTIONS.GET_CUSTOMERS,
  handler: function* () {
    const applicationId = yield selectWhen(InsuranceCalculationSelectors.selectApplicationId);

    const roles = yield call(InsuranceAnketaProviders.getCustomers, {
      applicationId,
      product: 'insurance',
    });

    const uniqueCustomerIDs = new Set();
    const customerRequests = [];

    for (const { customerId, isActive } of roles) {
      if (!isActive || uniqueCustomerIDs.has(customerId)) {
        continue;
      }

      uniqueCustomerIDs.add(customerId);
      customerRequests.push(call(InsuranceAnketaProviders.getCustomer, { customerId }));
    }

    const customers = yield all(customerRequests);

    yield put(
      InsuranceAnketaActions.setBatchState({
        [InsuranceAnketaConstants.FIELDS.CUSTOMER_ROLES]: roles,
        [InsuranceAnketaConstants.FIELDS.FILLED_CUSTOMERS]: customers,
      })
    );
  },
  name: InsuranceConstants.STAGES_FIELDS.GET_CUSTOMERS,
}).watcher;
